import React, { useState } from "react";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import Tooltip from "@mui/material/Tooltip";
import { useTranslate } from "react-admin";
import styles from "./CopyToClipboard.module.scss";

const CopyToClipboard = (props) => {
	const translate = useTranslate();
	const [open, setOpen] = useState(false);

	const handleTooltipClose = () => {
		setOpen(false);
	};

	const handleTooltipOpen = () => {
		setOpen(true);
		setTimeout(() => {
			setOpen(false);
		}, 2000);
	};

	const copyToClipboard = () => {
		if (props.children.length > 1) {
			navigator.clipboard.writeText(props.children[0].props.children);
		} else {
			navigator.clipboard.writeText(props.children.props.children);
		}
		handleTooltipOpen();
	};

	return (
		<div className={styles.flexRow}>
			{props.children}
			<Tooltip
				PopperProps={{ disablePortal: true }}
				onClose={handleTooltipClose}
				open={open}
				disableFocusListener
				disableHoverListener
				disableTouchListener
				title={translate("pos.main.copied")}
				arrow
			>
				<FileCopyIcon onClick={copyToClipboard} className={styles.copyIcon} />
			</Tooltip>
		</div>
	);
};

export default CopyToClipboard;
